import type React from "react"

const Faq = (): React.ReactElement => {
  window.location.replace("https://docs.openneuro.org/faq")
  return null
}

export default Faq
